import {Injectable} from '@angular/core';

import {IStorage} from '../interfaces/storage.interface';
import {LocalStorage} from '../models/localStorage.model';
import {SqlStorage} from '../models/sql.model';

@Injectable()
export class StorageService implements IStorage {
    storage: IStorage;

    constructor() {
        this.storage = new SqlStorage();
    }

    getItem(key: string): string {
        return this.storage.getItem(key);
    }

    setItem(key: string, value: string): void {
        return this.storage.setItem(key, value);
    }

    removeItem(key: string): void {
        return this.storage.removeItem(key);
    }
}
